var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgUsd = function SvgUsd(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1544_1918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 39.9999C31.0457 39.9999 40 31.0456 40 19.9999C40 8.95418 31.0457 -0.00012207 20 -0.00012207C8.95431 -0.00012207 0 8.95418 0 19.9999C0 31.0456 8.95431 39.9999 20 39.9999Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1304 20H39.9999C39.9999 18.1949 39.7593 16.4461 39.3109 14.7826H19.1304V20Z",
    fill: "#E4002B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1304 9.5652H37.0644C35.8401 7.56739 34.2747 5.80153 32.4496 4.34778H19.1304V9.5652Z",
    fill: "#E4002B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 40C24.7069 40 29.0333 38.3732 32.4497 35.6522H7.55029C10.9667 38.3732 15.293 40 20 40Z",
    fill: "#E4002B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.93545 30.4347H37.0645C38.0474 28.8309 38.8097 27.0778 39.311 25.2173H0.688965C1.19029 27.0778 1.95256 28.8309 2.93545 30.4347Z",
    fill: "#E4002B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.26437 3.12316H11.087L9.39164 4.3548L10.0392 6.34769L8.34398 5.11605L6.64875 6.34769L7.20813 4.62605C5.71547 5.86941 4.40719 7.32613 3.32906 8.94925H3.91305L2.83391 9.73324C2.66578 10.0137 2.50453 10.2986 2.35 10.5878L2.86531 12.1738L1.90391 11.4753C1.66492 11.9816 1.44633 12.4993 1.24984 13.0278L1.81758 14.7753H3.91305L2.21773 16.007L2.86531 17.9999L1.17008 16.7682L0.154609 17.5061C0.0529687 18.3231 0 19.1553 0 19.9999H20C20 8.95425 20 7.65207 20 -0.00012207C16.0491 -0.00012207 12.366 1.14597 9.26437 3.12316ZM10.0392 17.9999L8.34398 16.7682L6.64875 17.9999L7.29633 16.007L5.60102 14.7753H7.69648L8.34398 12.7825L8.99148 14.7753H11.087L9.39164 16.007L10.0392 17.9999ZM9.39164 10.1809L10.0392 12.1738L8.34398 10.9421L6.64875 12.1738L7.29633 10.1809L5.60102 8.94925H7.69648L8.34398 6.95636L8.99148 8.94925H11.087L9.39164 10.1809ZM17.2131 17.9999L15.5179 16.7682L13.8227 17.9999L14.4702 16.007L12.7749 14.7753H14.8704L15.5179 12.7825L16.1654 14.7753H18.2609L16.5655 16.007L17.2131 17.9999ZM16.5655 10.1809L17.2131 12.1738L15.5179 10.9421L13.8227 12.1738L14.4702 10.1809L12.7749 8.94925H14.8704L15.5179 6.95636L16.1654 8.94925H18.2609L16.5655 10.1809ZM16.5655 4.3548L17.2131 6.34769L15.5179 5.11605L13.8227 6.34769L14.4702 4.3548L12.7749 3.12316H14.8704L15.5179 1.13027L16.1654 3.12316H18.2609L16.5655 4.3548Z",
    fill: "#012169"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 39.5,
    height: 39.5,
    rx: 19.75,
    stroke: "#080808",
    strokeOpacity: 0.08,
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1544_1918"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUsd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "USD.6a52f7e75f7885ed40606019e92fab21.svg";